/**
 * Rota que não existe.
 *
 * Numa aplicação de página única o servidor devolve a casca para qualquer
 * caminho — ele não sabe quais rotas o roteador conhece. Então quem responde
 * "isto não existe" é o navegador, e sem esta tela o usuário veria a página
 * em branco, que é indistinguível de um erro de carregamento.
 */
import { Link } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta.js';
import { Header } from '../components/Header.jsx';
import { Panel } from '../components/Panel.jsx';

export function NotFound() {
  usePageMeta('AI Hub — página não encontrada');

  return (
    <>
      <Header badge="página não encontrada" />

      <main>
        <h1>Esta página não existe</h1>
        <p className="lead">
          O endereço <code>{window.location.pathname}</code> não corresponde a nenhuma tela da
          plataforma. Pode ser um link antigo ou um erro de digitação.
        </p>

        <Panel title="Para onde ir">
          <ul className="checks">
            <li>
              <Link to="/">Voltar ao início</Link>
            </li>
            <li>
              <Link to="/entrar">Entrar na plataforma</Link>
            </li>
          </ul>
        </Panel>
      </main>
    </>
  );
}
